import { render } from "./WhyGamefoundView.vue?vue&type=template&id=15c77849"
import script from "./WhyGamefoundView.vue?vue&type=script&lang=js"
export * from "./WhyGamefoundView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__